// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*=========================

  Text styles

 ==========================*/
h1 {
  margin: 0;
}

h2 {
  margin: 0;
  font-weight: 700;
  line-height: 160%;
}

h3 {
  margin: 0;
  font-weight: 700;
  line-height: 160%;
}

.normal-text {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
}

.label-text {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
}

.input-text {
  font-family: Inter, sans-serif;
  font-weight: 600;
  line-height: 160%;
}

.title1-text {
  font-style: normal;
  font-weight: 800;
  line-height: 140%;
}

.title2-text {
  font-weight: 800;
  line-height: 160%;
}

.title3-text {
  font-weight: 800;
  line-height: 160%;
}

.subtitle-text {
  font-style: normal;
  font-weight: 600;
  line-height: 160%;
}

.navigation-btn-text {
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: 0.9px;
}

.flex {
  display: flex;
  flex-direction: column;
}

.light-text-color {
  color: var(--light-text-color);
}

.dark-text-color {
  color: var(--dark-text-color);
}

@media only screen and (min-device-width: 320px) {
  h1 {
    font-size: 24px;
    font-weight: 800;
    line-height: 160%;
    letter-spacing: 0.96px;
  }
  h2, h3 {
    font-size: 16px;
    letter-spacing: 0.48px;
  }
  .normal-text {
    font-size: 16px;
    letter-spacing: 0.48px;
  }
  .label-text {
    font-size: 12px;
    letter-spacing: 0.8px;
  }
  .title1-text {
    font-size: 35px;
    letter-spacing: 2.1px;
  }
  .title2-text {
    font-size: 20px;
    letter-spacing: 1px;
  }
  .title3-text {
    font-size: 20px;
    letter-spacing: 0.8px;
  }
  .subtitle-text {
    font-size: 16px;
    letter-spacing: 0.48px;
  }
  .container {
    padding: 24px 5% 32px 5%;
  }
  .gap {
    gap: 12px;
  }
  .gap-larger {
    gap: 20px;
  }
  .text__container {
    max-width: 100%;
  }
}
@media only screen and (min-device-width: 768px) {
  h1 {
    font-size: 36px;
    font-weight: 800;
    line-height: 160%;
    letter-spacing: 1.44px;
  }
  h2, h3 {
    font-size: 20px;
    letter-spacing: 0.6px;
  }
  .normal-text {
    font-size: 18px;
    letter-spacing: 0.54px;
  }
  .label-text {
    font-size: 14px;
    letter-spacing: 0.9px;
  }
  .title1-text {
    font-size: 36px;
    letter-spacing: 2.16px;
  }
  .title2-text {
    font-size: 28px;
    letter-spacing: 1.4px;
  }
  .title3-text {
    font-size: 24px;
    letter-spacing: 0.96px;
  }
  .subtitle-text {
    font-size: 18px;
    letter-spacing: 0.54px;
  }
  .container {
    padding: 60px 9.5% 80px 9.5%;
  }
  .navigation-btn-text {
    font-size: 14px !important;
  }
  .gap {
    gap: 24px;
  }
  .gap-larger {
    gap: 44px;
  }
  .text__container {
    max-width: 680px;
  }
}
@media only screen and (min-device-width: 992px) {
  h1 {
    font-size: 52px;
    font-weight: 800;
    line-height: 160%;
    letter-spacing: 2.08px;
  }
  h2, h3 {
    font-size: 28px;
    letter-spacing: 0.84px;
  }
  .normal-text {
    font-size: 24px;
    letter-spacing: 0.72px;
  }
  .label-text {
    font-size: 18px;
    letter-spacing: 1px;
  }
  .title1-text {
    font-size: 56px;
    letter-spacing: 3.36px;
  }
  .title2-text {
    font-size: 36px;
    letter-spacing: 1.8px;
  }
  .title3-text {
    font-size: 32px;
    letter-spacing: 1.28px;
  }
  .subtitle-text {
    font-size: 24px;
    letter-spacing: 0.72px;
  }
  .container {
    padding: 100px 8.7% 120px 8.7%;
  }
  .navigation-btn-text {
    font-size: 14px !important;
  }
  .gap {
    gap: 32px;
  }
  .gap-larger {
    gap: 52px;
  }
  .text__container {
    max-width: 1126px;
  }
}
@media only screen and (min-device-width: 1366px) {
  h1 {
    font-size: 60px;
    font-weight: 800;
    line-height: 160%;
    letter-spacing: 2.4px;
  }
  h2, h3 {
    font-size: 32px;
    letter-spacing: 0.96px;
  }
  .normal-text {
    font-size: 28px;
    letter-spacing: 0.84px;
  }
  .label-text {
    font-size: 20px;
    letter-spacing: 1px;
  }
  .title1-text {
    font-size: 68px;
    letter-spacing: 4.08px;
  }
  .title2-text {
    font-size: 44px;
    letter-spacing: 2.2px;
  }
  .title3-text {
    font-size: 40px;
    letter-spacing: 1.6px;
  }
  .subtitle-text {
    font-size: 28px;
    letter-spacing: 0.84px;
  }
  .container {
    padding: 120px 9.4% 160px 9.4%;
  }
  .navigation-btn-text {
    font-size: 18px !important;
  }
  .gap {
    gap: 36px;
  }
  .gap-larger {
    gap: 52px;
  }
  .text__container {
    max-width: 1210px;
  }
}
@media only screen and (min-device-width: 1920px) {
  .container {
    padding: 120px 180px 160px 180px;
  }
}
.inter-font {
  font-family: Inter, serif;
}

/*=========================

  Color styles

 ==========================*/
#root {
  --primary-color: #1A7BD4;
  --accent-color: #F75929;
  --accent-color-hover: #F9683C;
  --accent-color-pressed: #EA4C1C;
  --error-color: #B72828;
  --border-color: #CCCCCC;
  --splitter-color: #444;
  --web-primary-color: #1B1B1B;
  --secondary-color: #F5F2ED;
  --secondary-color-hover: #F0EDE8;
  --secondary-color-pressed: #EAE7E2;
  --secondary-text-color: #9C9C9C;
  --text-color-1: #D9D9D9;
  --text-color-2: #C3C3C3;
  --background-color-1: #1B1B1B66;
  --background-color-2: #FFC2A0;
  --background-color-3: #FFE5DA;
  --white-color: #FFFFFF;
  --white-hover-color: #E6E9EB;
  --white-pressed-color: #DBDEE0;
  --white-disabled-color: #F1F4F6;
  --black-color: #111111;
  --mobile-min-width: 320px;
  --tablet-min-width: 768px;
  --medium-devices-min-width: 992px;
  --large-devices-min-width: 1200px;
  --light-text-color: #9E9E9E;
  --dark-text-color: #868686;
}`, "",{"version":3,"sources":["webpack://./src/local-styles.scss"],"names":[],"mappings":"AAAA;;;;4BAAA;AAKA;EACE,SAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;EACF;EACA;IACE,eAAA;IACA,sBAAA;EACF;EACA;IACE,eAAA;IACA,sBAAA;EACF;EACA;IACE,eAAA;IACA,qBAAA;EACF;EACA;IACE,eAAA;IACA,qBAAA;EACF;EACA;IACE,eAAA;IACA,mBAAA;EACF;EACA;IACE,eAAA;IACA,qBAAA;EACF;EACA;IACE,eAAA;IACA,sBAAA;EACF;EACA;IACE,wBAAA;EACF;EACA;IACE,SAAA;EACF;EACA;IACE,SAAA;EACF;EACA;IACE,eAAA;EACF;AACF;AAEA;EACE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;EAAF;EAEA;IACE,eAAA;IACA,qBAAA;EAAF;EAEA;IACE,eAAA;IACA,sBAAA;EAAF;EAEA;IACE,eAAA;IACA,qBAAA;EAAF;EAEA;IACE,eAAA;IACA,sBAAA;EAAF;EAEA;IACE,eAAA;IACA,qBAAA;EAAF;EAEA;IACE,eAAA;IACA,sBAAA;EAAF;EAEA;IACE,eAAA;IACA,sBAAA;EAAF;EAEA;IACE,4BAAA;EAAF;EAEA;IACE,0BAAA;EAAF;EAEA;IACE,SAAA;EAAF;EAEA;IACE,SAAA;EAAF;EAEA;IACE,gBAAA;EAAF;AACF;AAGA;EACE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,sBAAA;EADF;EAGA;IACE,eAAA;IACA,sBAAA;EADF;EAGA;IACE,eAAA;IACA,sBAAA;EADF;EAGA;IACE,eAAA;IACA,mBAAA;EADF;EAGA;IACE,eAAA;IACA,sBAAA;EADF;EAGA;IACE,eAAA;IACA,qBAAA;EADF;EAGA;IACE,eAAA;IACA,sBAAA;EADF;EAGA;IACE,eAAA;IACA,sBAAA;EADF;EAGA;IACE,8BAAA;EADF;EAGA;IACE,0BAAA;EADF;EAGA;IACE,SAAA;EADF;EAGA;IACE,SAAA;EADF;EAGA;IACE,iBAAA;EADF;AACF;AAIA;EACE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,qBAAA;EAFF;EAIA;IACE,eAAA;IACA,sBAAA;EAFF;EAIA;IACE,eAAA;IACA,sBAAA;EAFF;EAIA;IACE,eAAA;IACA,mBAAA;EAFF;EAIA;IACE,eAAA;IACA,sBAAA;EAFF;EAIA;IACE,eAAA;IACA,qBAAA;EAFF;EAIA;IACE,eAAA;IACA,qBAAA;EAFF;EAIA;IACE,eAAA;IACA,sBAAA;EAFF;EAIA;IACE,8BAAA;EAFF;EAIA;IACE,0BAAA;EAFF;EAIA;IACE,SAAA;EAFF;EAIA;IACE,SAAA;EAFF;EAIA;IACE,iBAAA;EAFF;AACF;AAKA;EACE;IACE,gCAAA;EAHF;AACF;AAUA;EACE,yBAAA;AARF;;AAWA;;;;4BAAA;AAMA;EACE,wBAAA;EACA,uBAAA;EACA,6BAAA;EACA,+BAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,0BAAA;EACA,gCAAA;EACA,kCAAA;EACA,+BAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;EACA,4BAAA;EACA,8BAAA;EACA,+BAAA;EACA,sBAAA;EACA,yBAAA;EACA,yBAAA;EACA,iCAAA;EACA,iCAAA;EACA,2BAAA;EACA,0BAAA;AATF","sourcesContent":["/*=========================\n\n  Text styles\n\n ==========================*/\nh1 {\n  margin: 0;\n}\n\nh2 {\n  margin: 0;\n  font-weight: 700;\n  line-height: 160%;\n}\n\nh3 {\n  margin: 0;\n  font-weight: 700;\n  line-height: 160%;\n}\n\n.normal-text {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 160%\n}\n\n.label-text {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 160%\n}\n\n.input-text {\n  font-family: Inter, sans-serif;\n  font-weight: 600;\n  line-height: 160%;\n}\n\n.title1-text {\n  font-style: normal;\n  font-weight: 800;\n  line-height: 140%;\n}\n\n.title2-text {\n  font-weight: 800;\n  line-height: 160%;\n}\n\n.title3-text {\n  font-weight: 800;\n  line-height: 160%;\n}\n\n.subtitle-text {\n  font-style: normal;\n  font-weight: 600;\n  line-height: 160%;\n}\n\n.navigation-btn-text {\n  font-family: Inter, sans-serif;\n  font-style: normal;\n  font-weight: 800;\n  line-height: normal;\n  letter-spacing: 0.9px;\n}\n\n.flex {\n  display: flex;\n  flex-direction: column;\n}\n\n.light-text-color {\n  color: var(--light-text-color);\n}\n\n.dark-text-color {\n  color: var(--dark-text-color);\n}\n\n@media only screen and (min-device-width: 320px) {\n  h1 {\n    font-size: 24px;\n    font-weight: 800;\n    line-height: 160%;\n    letter-spacing: 0.96px;\n  }\n  h2, h3 {\n    font-size: 16px;\n    letter-spacing: 0.48px;\n  }\n  .normal-text {\n    font-size: 16px;\n    letter-spacing: 0.48px;\n  }\n  .label-text {\n    font-size: 12px;\n    letter-spacing: 0.8px;\n  }\n  .title1-text {\n    font-size: 35px;\n    letter-spacing: 2.1px;\n  }\n  .title2-text {\n    font-size: 20px;\n    letter-spacing: 1px;\n  }\n  .title3-text {\n    font-size: 20px;\n    letter-spacing: 0.8px;\n  }\n  .subtitle-text {\n    font-size: 16px;\n    letter-spacing: 0.48px;\n  }\n  .container {\n    padding: 24px 5% 32px 5%;\n  }\n  .gap {\n    gap: 12px;\n  }\n  .gap-larger {\n    gap: 20px;\n  }\n  .text__container {\n    max-width: 100%;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  h1 {\n    font-size: 36px;\n    font-weight: 800;\n    line-height: 160%;\n    letter-spacing: 1.44px;\n  }\n  h2, h3 {\n    font-size: 20px;\n    letter-spacing: 0.6px;\n  }\n  .normal-text {\n    font-size: 18px;\n    letter-spacing: 0.54px;\n  }\n  .label-text {\n    font-size: 14px;\n    letter-spacing: 0.9px;\n  }\n  .title1-text {\n    font-size: 36px;\n    letter-spacing: 2.16px;\n  }\n  .title2-text {\n    font-size: 28px;\n    letter-spacing: 1.4px;\n  }\n  .title3-text {\n    font-size: 24px;\n    letter-spacing: 0.96px;\n  }\n  .subtitle-text {\n    font-size: 18px;\n    letter-spacing: 0.54px;\n  }\n  .container {\n    padding: 60px 9.5% 80px 9.5%;\n  }\n  .navigation-btn-text {\n    font-size: 14px !important;\n  }\n  .gap {\n    gap: 24px;\n  }\n  .gap-larger {\n    gap: 44px;\n  }\n  .text__container {\n    max-width: 680px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  h1 {\n    font-size: 52px;\n    font-weight: 800;\n    line-height: 160%;\n    letter-spacing: 2.08px;\n  }\n  h2, h3 {\n    font-size: 28px;\n    letter-spacing: 0.84px;\n  }\n  .normal-text {\n    font-size: 24px;\n    letter-spacing: 0.72px;\n  }\n  .label-text {\n    font-size: 18px;\n    letter-spacing: 1px;\n  }\n  .title1-text {\n    font-size: 56px;\n    letter-spacing: 3.36px;\n  }\n  .title2-text {\n    font-size: 36px;\n    letter-spacing: 1.8px;\n  }\n  .title3-text {\n    font-size: 32px;\n    letter-spacing: 1.28px;\n  }\n  .subtitle-text {\n    font-size: 24px;\n    letter-spacing: 0.72px;\n  }\n  .container {\n    padding: 100px 8.7% 120px 8.7%;\n  }\n  .navigation-btn-text {\n    font-size: 14px !important;\n  }\n  .gap {\n    gap: 32px;\n  }\n  .gap-larger {\n    gap: 52px;\n  }\n  .text__container {\n    max-width: 1126px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  h1 {\n    font-size: 60px;\n    font-weight: 800;\n    line-height: 160%;\n    letter-spacing: 2.4px;\n  }\n  h2, h3 {\n    font-size: 32px;\n    letter-spacing: 0.96px;\n  }\n  .normal-text {\n    font-size: 28px;\n    letter-spacing: 0.84px;\n  }\n  .label-text {\n    font-size: 20px;\n    letter-spacing: 1px;\n  }\n  .title1-text {\n    font-size: 68px;\n    letter-spacing: 4.08px;\n  }\n  .title2-text {\n    font-size: 44px;\n    letter-spacing: 2.2px;\n  }\n  .title3-text {\n    font-size: 40px;\n    letter-spacing: 1.6px;\n  }\n  .subtitle-text {\n    font-size: 28px;\n    letter-spacing: 0.84px;\n  }\n  .container {\n    padding: 120px 9.4% 160px 9.4%;\n  }\n  .navigation-btn-text {\n    font-size: 18px !important;\n  }\n  .gap {\n    gap: 36px;\n  }\n  .gap-larger {\n    gap: 52px;\n  }\n  .text__container {\n    max-width: 1210px;\n  }\n}\n\n@media only screen and (min-device-width: 1920px) {\n  .container {\n    padding: 120px 180px 160px 180px;\n  }\n  //body {\n  //  display: flex;\n  //  justify-content: center;\n  //}\n}\n\n.inter-font {\n  font-family: Inter, serif;\n}\n\n/*=========================\n\n  Color styles\n\n ==========================*/\n\n#root {\n  --primary-color: #1A7BD4;\n  --accent-color: #F75929;\n  --accent-color-hover: #F9683C;\n  --accent-color-pressed: #EA4C1C;\n  --error-color: #B72828;\n  --border-color: #CCCCCC;\n  --splitter-color: #444;\n  --web-primary-color: #1B1B1B;\n  --secondary-color: #F5F2ED;\n  --secondary-color-hover: #F0EDE8;\n  --secondary-color-pressed: #EAE7E2;\n  --secondary-text-color: #9C9C9C;\n  --text-color-1: #D9D9D9;\n  --text-color-2: #C3C3C3;\n  --background-color-1: #1B1B1B66;\n  --background-color-2: #FFC2A0;\n  --background-color-3: #FFE5DA;\n  --white-color: #FFFFFF;\n  --white-hover-color: #E6E9EB;\n  --white-pressed-color: #DBDEE0;\n  --white-disabled-color: #F1F4F6;\n  --black-color: #111111;\n  --mobile-min-width: 320px;\n  --tablet-min-width: 768px;\n  --medium-devices-min-width: 992px;\n  --large-devices-min-width: 1200px;\n  --light-text-color: #9E9E9E;\n  --dark-text-color: #868686;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
